const MinMaxProductMessage = (props) => {
  const { club, itemCount } = props;
  if (!club.subscription.minQuantityInShipment) {
    return renderItemCount(itemCount);
  }
  return (
    <>
      Your order must be a minimum of{' '}
      {renderBoldItem(club.subscription.minQuantityInShipment)}.{' '}
      {renderItemCount(itemCount)}
    </>
  );
};

export default MinMaxProductMessage;

const renderBoldItem = (itemCount) => {
  if (itemCount === 1) {
    return <strong>1 item</strong>;
  }
  return <strong>{itemCount} items</strong>;
};

const renderItemCount = (itemCount) => {
  if (itemCount === 0) {
    return (
      <>
        Currently there are <strong>no items</strong> in your club shipment.
      </>
    );
  }
  if (itemCount === 1) {
    return (
      <>
        Currently there is <strong>1 item</strong> in your club shipment.
      </>
    );
  }
  return (
    <>
      Currently there are <strong>{itemCount} items</strong> in your club
      shipment.
    </>
  );
};
